<template>
    <div >
      <RequiredText />
      <Input
          :name="`${id}-name`"
          :label="$t('crm.label.label')"
          :placeholder="$t('crm.label.label')"
          v-model="formData.title"
      />
      <Select2
          :parent-id="`#${id}`"
          :multiple="false"
          :name="`${id}-call-type`"
          :label="$t('crm.label.type')"
          :placeholder-text="$t('crm.label.select_type')"
          v-model="formData.type"
      >
        <option v-for="(type, index) in callActivityTypeEnum" :value="type.value" :key="index" >
          {{ type[locale] }}
        </option>
      </Select2>
      <div class="row">
        <InputDate2
            container-class="col-6"
            :name="`${id}-call-datetime`"
            :label="$t('crm.label.date')"
            v-model="formData.date"
            :placeholder="$t('crm.label.date')"
        />
        <Input
          container-class="col-6"
          type="time"
          :name="`${id}-call-time`"
          :label="$t('crm.label.time')"
          v-model="formData.time"
          :placeholder="$t('crm.label.time')"
        />
      </div>
      <Select2
          :parent-id="`#${id}`"
          :multiple="false"
          :name="`${id}-call-priority`"
          :label="$t('crm.label.priority')"
          :placeholder-text="$t('crm.label.select_priority')"
          v-model="formData.priority"
      >
        <option v-for="(priority, index) in opportunityPriorityEnum" :value="priority.value" :key="index" >
          {{ priority[locale] }}
        </option>
      </Select2>
      <div class="row" v-show="past">
        <label class="form-label">{{ $t('appointments.label.reminder') }} <span class="text-danger"> * </span> </label>
        <div class="input-group">
          <Input
              containerClass="form-group col-3 col-md-3 col-lg-3 mt-auto mb-5"
              :name="`frequence_number`"
              type="number"
              :min="0"
              :inputClass="'form-control form-control-lg form-control-solid'"
              :isRequired="true"
              :placeholder="$t('appointments.label.placeholder_reminder_number')"
              v-model="formData.remind_frequency_count"
          />
          <Select2
              :parent-id="`#${id}`"
              container-class="form-group col-9 col-md-9 col-lg-9 mt-auto mb-5"
              :multiple="false"
              :show-search="true"
              :selectClass="'form-select form-control-sm form-select-solid'"
              :name="`reminder`"
              :isRequired="true"
              :placeholder-text="$t('appointments.label.placeholder_reminder')"
              v-model="formData.remind_frequency"
          >
            <option v-for="(item, index) in frequencyEnum" :key="index" :value="item.value">
              {{ item[locale] }}
            </option>
          </Select2>
        </div>
      </div>
    </div>
</template>

<script setup>
import { computed, ref, defineProps, watch } from "vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText"
import InputDate2 from "@/components/InputDate2.vue"
import Select2 from "@/components/Select2.vue"
import {useLocales} from "@/composables/locales";
import {compareDateToToday} from "@/mixins/Helpers"

const { locale } = useLocales()

const store = useStore()
const props = defineProps({
  form: {
    type: Object,
    default: {
      type: null,
      title: null,
      priority: null,
      datetime: null,
      note: '',
      remind_frequency_count: null,
      remind_frequency: null
    }
  },
  id: {
    type: String,
    required: true
  }
})

const formData = ref(props.form)

const callActivityTypeEnum = computed(() => store.getters['activity/callActivityTypeEnum'])
const opportunityPriorityEnum = computed(() => store.getters['pipelines/pipelinePriorityEnum'])
const frequencyEnum = computed(() => store.getters["pipelines/getActivityRemindEnum"])
const past = computed(() => {
  let datetime = formData.value.date + ' ' + formData.value.time
  return compareDateToToday(formData.value.date+' 00:00') || compareDateToToday(datetime)
})
</script>

<style scoped>
.icon-wrapper {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper i {
    position: relative;
    font-size: 1.5em;
  }

  .icon-wrapper .icon-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
    margin-top: 8px;
  }
</style>
